import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { DatePickerInput } from "rc-datepicker";
import { FormGroup } from "react-bootstrap";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import Images from "assets/images/imageData";

const SalesFilterForm = ({
  applyFilter,
  status = [],
  reportees = [],
  cities = [],
  lead_category = [],
  zones = [],
  getZones,
  getAreas,
  statusId,
  isRoleId,
  projectOnboardingStatus = false
}) => {
  const filterInputs = {
    leadID: "",
    siteID: "",
    leadStatus: statusId,
    clientNameOrPartnerName: "",
    createdOnDate: "",
    fromDate: "",
    toDate: "",
    leadOwnerOrAssignee: "",
    lead_type:"",
    city: "",
    lead_cat: "",
    zone: "",
    commercial_type_id: "",
    project_status:""
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [listStatus, setListStatus] = useState("");
  const [isFocus1, setIsFous1] = useState(false);
  const [isFocus2, setIsFous2] = useState(false);
  const [isFocus3, setIsFous3] = useState(false);
  const [isFocus4, setIsFous4] = useState(false);
  const [isFocus5, setIsFous5] = useState(false);
  const [isFocus6, setIsFous6] = useState(false);
  const [isFocus7, setIsFous7] = useState(false);
  const [leadOwner, setLeadOwner] = useState("");
  const [commercialType, setCommercialType] = useState("");
  const [projectStatusValue, setprojectStatusValue] = useState("");


  const handleDateChange1 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      createdOnDate: dateString,
    });
  };
  const handleDateChange2 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      fromDate: dateString,
    });
  };
  const handleDateChange3 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      toDate: dateString,
    });
  };

  const handleDateChange4 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      lcfromDate: dateString,
    });
  };
  const handleDateChange5 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      lctoDate: dateString,
    });
  };

  const handleDateChange6 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      ncfromDate: dateString,
    });
  };
  const handleDateChange7 = (jsdate, dateString) => {
    setFilterFieldsData({
      ...filterFieldsData,
      nctoDate: dateString,
    });
  };

  const handleDateHide1 = () => {
    if (!filterFieldsData.createdOnDate) {
      setIsFous1(true);
    }
  };
  const handleDateHide2 = () => {
    if (!filterFieldsData.fromDate) {
      setIsFous2(true);
    }
  };
  const handleDateHide3 = () => {
    if (!filterFieldsData.toDate) {
      setIsFous3(true);
    }
  };

  const handleDateHide4 = () => {
    if (!filterFieldsData.fromDate) {
      setIsFous4(true);
    }
  };
  const handleDateHide5 = () => {
    if (!filterFieldsData.toDate) {
      setIsFous5(true);
    }
  };

  const handleDateHide6 = () => {
    if (!filterFieldsData.fromDate) {
      setIsFous6(true);
    }
  };
  const handleDateHide7 = () => {
    if (!filterFieldsData.toDate) {
      setIsFous7(true);
    }
  };

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(
        localStorage.getItem("applyFilter") &&
          localStorage.getItem("applyFilter")
      );
      const status = await JSON.parse(
        localStorage.getItem("statusFilter") &&
          localStorage.getItem("statusFilter")
      );
      if (roles && status) {
        console.log(roles)
        setFilterFieldsData(roles);
        setListStatus(status);
      }
    })();
  }, []);


  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
        filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
        listStatus && localStorage.setItem("statusFilter", JSON.stringify(listStatus));
      }}
    >
      <ConstantInput
        label={localization.leadNumber}
        value={filterFieldsData && filterFieldsData.leadID}
        regex={Regex.number.test(filterFieldsData && filterFieldsData?.leadID)}
        type="number"
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, leadID: val });
        }}
      />

      <ConstantInput
        label={localization.siteNumber}
        value={filterFieldsData && filterFieldsData.siteID}
        regex={Regex.number.test(filterFieldsData && filterFieldsData?.siteID)}
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, siteID: val });
        }}
      />

      <DropDownInput
        disabled={status.length === 0}
        label={localization.leadStatus}
        data={status}
        getIdValue={(val) => {
          setFilterFieldsData({ ...filterFieldsData, leadStatus: val.id });
          setListStatus(val);
        }}
        value={listStatus && listStatus.value}
      />

      <ConstantInput
        label={localization.clientBuildingOrPartnerName}
        value={filterFieldsData && filterFieldsData.clientNameOrPartnerName}
        regex={Regex.text.test(
          filterFieldsData && filterFieldsData?.clientNameOrPartnerName
        )}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({
            ...filterFieldsData,
            clientNameOrPartnerName: val,
          })
        }
      />

      <DropDownInput
          label={localization.commercialType}
          data={[
            {id: 5, name: "Capex",},
            {id: 6, name: "Opex-Ownership",},
            {id: 7, name: "Rental",},
          ]}
          getIdValue={(val) =>{
            setFilterFieldsData({
              ...filterFieldsData,
              commercial_type_id: val.id,
            })
            setCommercialType(val.value)
          }
          }
          value={commercialType && commercialType}
      />

      {projectOnboardingStatus &&
          <>
          {/*<DropDownInput*/}
          {/*    label={localization.projectStatus}*/}
          {/*    data={[*/}
          {/*      {id: 0, name: "Pending",},*/}
          {/*      {id: 1, name: "Approved",},*/}
          {/*      {id: 2, name: "Rejected",},*/}
          {/*    ]}*/}
          {/*    getIdValue={(val) =>{*/}
          {/*      setFilterFieldsData({*/}
          {/*        ...filterFieldsData,*/}
          {/*        project_status: val.id,*/}
          {/*      })*/}
          {/*      setprojectStatusValue(val.value)*/}
          {/*    }*/}
          {/*    }*/}
          {/*    value={projectStatusValue}*/}
          {/*/>*/}
            <DropDownInput
                label={localization.leadType}
                data={[
                  { id: 1, name: 'Corporate' },
                  { id: 2, name: 'RWA' },
                  { id: 4, name: 'Supply' },
                ]}
                getIdValue={(val) =>{
                  setFilterFieldsData({
                    ...filterFieldsData,
                    lead_type: val.id,
                  })
                  setLeadOwner(val.value)
                }
                }
                value={leadOwner && leadOwner}
            />
          </>
      }

      <fieldset>
        <h4>{localization.createdBetween}</h4>

        <FormGroup
          className={`date custom_date_picker ${isFocus2 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange2}
            value={filterFieldsData.fromDate}
            autoClose
            onShow={() => setIsFous2(true)}
            onHide={handleDateHide2}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            maxDate={new Date()}
          />
          <label>{localization.fromDate}</label>
        </FormGroup>

        <FormGroup
          className={`date custom_date_picker ${isFocus3 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange3}
            value={filterFieldsData.toDate}
            autoClose
            onShow={() => setIsFous3(true)}
            onHide={handleDateHide3}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            maxDate={new Date()}
          />

          <label>{localization.toDate}</label>
        </FormGroup>
      </fieldset>
      

      {isRoleId != 7 && isRoleId != 19 && (
        <DropDownInput
          disabled={reportees.length === 0}
          label={localization.leadOwnerOrAssignee}
          data={reportees}
          getIdValue={(val) =>{
            setFilterFieldsData({
              ...filterFieldsData,
              leadOwnerOrAssignee: val.id,
            })
            setLeadOwner(val.value)
            }
          }
          value={leadOwner && leadOwner}
        />
      )}
      {isRoleId === 19 && (
        <DropDownInput
          label={localization.leadType}
          data={[
            {id: 1, name: "Corporate",},
            {id: 2, name: "Apartment",},
            {id: 3, name: "B2B/B2C Alliance",},
            {id: 4, name: "Supply",},
          ]}
          getIdValue={(val) =>{
            setFilterFieldsData({
              ...filterFieldsData,
              lead_type: val.id,
            })
            setLeadOwner(val.value)
            }
          }
          value={leadOwner && leadOwner}
        />
      )}

    <DropDownInput
        disabled={lead_category.length === 0}
        label={localization.LeadCategory}
        data={lead_category}
        getIdValue={(val) => {
          setFilterFieldsData({ ...filterFieldsData, lead_cat: val.id });
        }}
        value={filterFieldsData && filterFieldsData.lead_cat}
      />
      <DropDownInput
        disabled={cities.length === 0}
        label={localization.city}
        data={cities}
        getIdValue={(val) => {
          setFilterFieldsData({ ...filterFieldsData, city: val.id });
          getZones(val.id);
        }}
        value={filterFieldsData && filterFieldsData.city}
      />
      
      <DropDownInput
       disabled={zones.length === 0}
       label={localization.zone}
       data={zones.length ? zones : []}
        getIdValue={(val) => {
          setFilterFieldsData({ ...filterFieldsData, zone: val.id });
          
        }}
        value={filterFieldsData && filterFieldsData.zone}
      />

      <DropDownInput
        disabled={zones.length === 0}
        label={localization.area}
        data={zones.length ? zones : []}
        getIdValue={(val) => {
          setFilterFieldsData({ ...filterFieldsData, zone: val.id });
          
        }}
        value={filterFieldsData && filterFieldsData.zone}
      />

      {/* <DropDownInput
        disabled={zones.length === 0}
        label={localization.zone}
        data={zones.length ? zones : []}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, zone: val.id })
        }
        value={filterFieldsData && filterFieldsData.zone}
      /> */}

       {/* <DropDownInput
        disabled={zones.length === 0}
        label={localization.zone}
        data={zones.length ? zones : []}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, zone: val.id })
        }
        value={filterFieldsData && filterFieldsData.zone}
      /> */}


<fieldset>
        <h4>{localization.lastContactDate}</h4>

        <FormGroup
          className={`date custom_date_picker ${isFocus4 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange4}
            value={filterFieldsData.fromDate}
            autoClose
            onShow={() => setIsFous4(true)}
            onHide={handleDateHide4}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            maxDate={new Date()}
          />
          <label>{localization.fromDate}</label>
        </FormGroup>

        <FormGroup
          className={`date custom_date_picker ${isFocus5 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange5}
            value={filterFieldsData.toDate}
            autoClose
            onShow={() => setIsFous5(true)}
            onHide={handleDateHide5}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            maxDate={new Date()}
          />

          <label>{localization.toDate}</label>
        </FormGroup>
      </fieldset>

      {/* nextContactDate */}
      <fieldset>
        <h4>{localization.nextContactDate}</h4>

        <FormGroup
          className={`date custom_date_picker ${isFocus6 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange6}
            value={filterFieldsData.fromDate}
            autoClose
            onShow={() => setIsFous6(true)}
            onHide={handleDateHide6}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            maxDate={new Date()}
          />
          <label>{localization.fromDate}</label>
        </FormGroup>

        <FormGroup
          className={`date custom_date_picker ${isFocus7 ? "active-date" : ""}`}
        >
          <DatePickerInput
            onChange={handleDateChange7}
            value={filterFieldsData.toDate}
            autoClose
            onShow={() => setIsFous7(true)}
            onHide={handleDateHide7}
            closeOnClickOutside
            showOnInputClick
            locale="en"
            className="my-custom-datepicker-component"
            displayFormat="DD-MM-YYYY"
            returnFormat="DD-MM-YYYY"
            maxDate={new Date()}
          />

          <label>{localization.toDate}</label>
        </FormGroup>
      </fieldset>


      <br />
      <br />
      <br />

      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src={Images?.ArrowRight} alt="" />
        </button>
        <br/>
        <br/>
        <button
          onClick={() => {
            localStorage.setItem("applyFilter", JSON.stringify(filterInputs));
            applyFilter(filterInputs);
            localStorage.setItem("statusFilter", JSON.stringify({}));
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default SalesFilterForm;
